// Limite da API de timers do navegador, não um intervalo de negócio.
const MAX_TIMER_DELAY_MS = 2 ** 31 - 1;

/** Validação compartilhada pelo build e pela reconciliação no navegador. */
function parseTimerInterval(rawValue: string | undefined, configName: string): number {
  const value = Number(rawValue);
  if (!Number.isInteger(value) || value <= 0 || value > MAX_TIMER_DELAY_MS) {
    throw new Error(`${configName} deve ser um inteiro positivo válido para timers.`);
  }
  return value;
}

export function parseSubscriptionPollingInterval(rawValue: string | undefined): number {
  return parseTimerInterval(rawValue, 'VITE_SUBSCRIPTION_POLL_INTERVAL_MS');
}

export function parseSubscriptionPollingConfig(
  initialValue: string | undefined,
  maxValue: string | undefined,
): { intervalMs: number; maxIntervalMs: number } {
  const intervalMs = parseSubscriptionPollingInterval(initialValue);
  const maxIntervalMs = parseTimerInterval(maxValue, 'VITE_SUBSCRIPTION_POLL_MAX_INTERVAL_MS');
  if (maxIntervalMs < intervalMs) {
    throw new Error('VITE_SUBSCRIPTION_POLL_MAX_INTERVAL_MS deve ser maior ou igual ao intervalo inicial.');
  }
  return { intervalMs, maxIntervalMs };
}
